<div class="popup-disabled p-3 p-md-4 configurable-card-border">
  <div class="popup-title"><i class="bi bi-exclamation-triangle-fill"></i> {{ 'terminal_temporary_disabled' | translation }} </div>
  <div>
    <p class="mt-3 mb-4 text-muted">
      {{ 'terminal_reactivation_required_to_view_data' | translation }}
    </p>
    <div class="text-end">
      <button id="reviseTerminals" type="submit" class="btn btn-primary" (click)="reviseTerminal()">
        {{ 'terminal_check' | translation }}
      </button>
    </div>
  </div>
</div>
